import CountDownTimer from "@/common/components/countdown-timer";
import ArrowRightIcon from "@/common/svgs/arrow-right";
import { Button } from "@/components/ui/button";
import { GiveawayDetailsRoute } from "@/features/home/route";
import { getOfficialDrawDateWithSuffix } from "@/lib/date";
import { useNavigate } from "react-router-dom";
import { Promotion } from "../models/giveaway";

function CurrentPromotion({ promotion }: { promotion: Promotion }) {
	const navigate = useNavigate();
	const baseURL = import.meta.env.VITE_SERVER_API_URL;
	const prizeImage = `${baseURL}/common/image/${promotion.prize.images[0]?.url}`;

	return (
		<div className="flex flex-col rounded-[32px] bg-white max-sm:w-full md:flex-row md:gap-12 md:rounded-[64px]">
			<div className="w-full p-6 pb-0 md:w-1/2 md:p-16 md:pr-0">
				<img src={prizeImage} className="h-50 w-full rounded-[32px] md:h-125" />
			</div>

			<div className="flex w-full flex-col justify-between p-6 max-sm:gap-12 md:w-1/2 md:p-16 md:pl-0">
				<div className="flex flex-col gap-12 md:gap-8">
					<div className="bg-blue w-fit rounded-[16px] p-3 md:p-4">
						<p className="web-heading-h4 text-blue-500">
							Valued AT ${promotion.prize.cost.toLocaleString()}
						</p>
					</div>
					<div className="flex flex-col gap-6">
						<p className="web-heading-h3">Win This: {promotion.prize.title}</p>
						<p className="web-body-b1">{promotion.prize.description}</p>
					</div>
					<span className="web-heading-h4">
						Winner Drawn:{" "}
						<span className="web-heading-h4-regular">
							{getOfficialDrawDateWithSuffix(new Date(promotion.endDate))} 7:00
							pm
						</span>
					</span>
				</div>

				<div className="flex flex-col justify-between gap-6 md:flex-row">
					<CountDownTimer targetDate={new Date(promotion.endDate)} />

					<Button
						onClick={() =>
							navigate(GiveawayDetailsRoute + "?id=" + promotion.id)
						}
						className="flex flex-row items-center justify-center gap-3 md:w-60"
					>
						See Details <ArrowRightIcon white />
					</Button>
				</div>
			</div>
		</div>
	);
}

export default CurrentPromotion;
